import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=8064f01e&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8064f01e')) {
      api.createRecord('8064f01e', component.options)
    } else {
      api.reload('8064f01e', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=8064f01e&", function () {
      api.rerender('8064f01e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BWpTzN664qrW/JS/comp/ImgFallback.vue"
export default component.exports